import api from '@/apis/sa/sAElectronicTicketAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sAElectronicTicket', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_sale_invoice',
    field: {
      key: 'ref_id',
      transaction: 'transaction_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Update lại trường hạch toán màn hình danh sách
   * @param {*} context
   * @param {*} res
   * NNLINH 12.04.2023
   */
   updatedPosted(context, res) {
    context.commit('updatedPosted', res);
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * Update lại trường hạch toán ngoài màn hình danh sách
   * @param {*} state
   * @param {*} ids
   * NNLINH 12.04.2023
   */
   updatedPosted(state, ids) {
    let keyField = state._config.field.key;
    if (ids.length) {
      ids.forEach(id => {
        for (let i = 0; i < state.items.length; i++) {
          let item = state.items[i];

          if (item[keyField] === id) {
            let itemNew = { ...item };
            itemNew.is_posted = true;
            //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
            Object.assign(item, itemNew);
            break;
          }
        }
      });
    }
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
